var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.596 4.602-.709.247c-.019.006-1.939.664-4.976.664-1.547 0-3.021-.314-4.445-.617-1.441-.307-2.931-.625-4.508-.625-3.146 0-4.212.675-4.324.752l-.23.159v22.547H7.47V17.533c.424-.166 1.465-.461 3.487-.461 1.465 0 2.835.292 4.286.601 1.479.316 3.008.641 4.667.641 3.233 0 5.245-.695 5.33-.724l.356-.125V4.601zM24.53 16.691c-.69.188-2.34.558-4.62.558-1.547 0-3.021-.314-4.445-.618-1.441-.307-2.931-.625-4.508-.625-1.727 0-2.828.204-3.487.4V5.797c.427-.166 1.47-.46 3.487-.46 1.465 0 2.835.292 4.286.601 1.479.315 3.008.641 4.667.641 2.148 0 3.756-.307 4.62-.521V16.69z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.bf127694e7d8e1d5a4f2d9cb08c33223.svg";
export { ForwardRef as ReactComponent };